import {
  checkoutAuctionPayment
} from "./chunk-IDRAWCQV.mjs";
import {
  getAuctionPaymentDetails
} from "./chunk-FEFRDEYL.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/auction/payment.ts
import { useMutation, useQuery } from "@tanstack/react-query";
var useGetAuctionPaymentDetails = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getAuctionPaymentDetails", props],
    queryFn: () => getAuctionPaymentDetails(props)
  }, options));
};
var useCheckoutAuctionPayment = (options) => {
  return useMutation(__spreadValues({
    mutationFn: checkoutAuctionPayment
  }, options));
};

export {
  useGetAuctionPaymentDetails,
  useCheckoutAuctionPayment
};
//# sourceMappingURL=chunk-ZB2UY72N.mjs.map